export function toggleFilterValue<T>(filterValue: T, filtersField: T[] | undefined): T[] {
  if (!filtersField) {
    return [filterValue];
  }

  return !filtersField.includes(filterValue)
    ? [...filtersField, filterValue]
    : filtersField.filter(type => type !== filterValue);
}
